<template>
  <div class="highlight-sns-button-parts">
    <h3 class="highlight-sns-button-parts__title">
      <span class="highlight-sns-button-parts__title-label">{{
        $tc('RaceVideoPage.highlights.comment.sns')
      }}</span>
      <span class="highlight-sns-button-parts__title-label-short">{{
        $tc('RaceVideoPage.highlights.comment.snsShort')
      }}</span>
    </h3>
    <ul class="highlight-sns-button-parts__buttons">
      <li class="highlight-sns-button-parts__buttons-item" ref="buttonX">
        <button
          class="highlight-sns-button-parts__button"
          :class="{
            'highlight-sns-button-parts__button--active': postX,
            'highlight-sns-button-parts__button--activeBalloon': isActiveXBalloon,
          }"
          @click="onChangePostX"
        >
          <label for="comment" class="highlight-sns-button-parts__button-label"
            ><highlights-x-icon
          /></label>
          <span class="highlight-sns-button-parts__button-check" v-if="isXPosted">
            <highlight-check-active-icon v-if="postX" />
            <highlight-check-icon v-else />
          </span>
        </button>
        <div
          v-if="isActiveXBalloon"
          class="highlight-sns-button-parts__balloon"
          ref="balloonX"
          :style="balloonXStyle"
        >
          <highlights-sns-balloon-parts />
        </div>
      </li>
      <li v-if="false" class="highlight-sns-button-parts__buttons-item" ref="buttonInstagram">
        <button
          class="highlight-sns-button-parts__button"
          :class="{
            'highlight-sns-button-parts__button--active': postInstagram,
            'highlight-sns-button-parts__button--activeBalloon': isActiveInstagramBalloon,
          }"
          @click="onChangePostInstagram"
        >
          <label for="comment" class="highlight-sns-button-parts__button-label"
            ><highlights-instagram-icon
          /></label>
          <span class="highlight-sns-button-parts__button-check" v-if="isInstagramPosted">
            <highlight-check-active-icon v-if="postInstagram" />
            <highlight-check-icon v-else />
          </span>
        </button>
        <div
          v-if="isActiveInstagramBalloon"
          class="highlight-sns-button-parts__balloon"
          ref="balloonInstagram"
        >
          <highlights-sns-balloon-parts />
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import HighlightsXIcon from '@/components/RaceVideoPage/RaceVideoHighlightsPane/parts/icons/HighlightsXIcon.vue'
import HighlightsInstagramIcon from '@/components/RaceVideoPage/RaceVideoHighlightsPane/parts/icons/HighlightsInstagramIcon.vue'
import HighlightsSnsBalloonParts from '@/components/RaceVideoPage/RaceVideoHighlightsPane/parts/HighlightsSnsBalloonParts.vue'
import HighlightCheckIcon from '@/components/RaceVideoPage/RaceVideoHighlightsPane/parts/icons/HighlightCheckIcon.vue'
import HighlightCheckActiveIcon from '@/components/RaceVideoPage/RaceVideoHighlightsPane/parts/icons/HighlightCheckActiveIcon.vue'
import { HighlightPostedSnsType } from '@/store/stores/collectionModule/documents/highlight/HighlightDocument'

interface SnsButtonDataTypes {
  isActiveXBalloon: boolean
  isActiveInstagramBalloon: boolean
  timerXId: number | undefined
  timerInstagramId: number | undefined
  balloonDisplayTime: number
  balloonXStyle: object
  balloonInstagramStyle: object
  isXPosted: boolean
  isInstagramPosted: boolean
}

export default defineComponent({
  name: 'HighlightsSnsButtonParts',
  components: {
    HighlightCheckActiveIcon,
    HighlightCheckIcon,
    HighlightsSnsBalloonParts,
    HighlightsInstagramIcon,
    HighlightsXIcon,
  },
  props: {
    /**
     * Xにハイライトを投稿するかどうか
     */
    postX: {
      type: Boolean,
      default: false,
    },
    /**
     * Instagramにハイライトを投稿するかどうか
     */
    postInstagram: {
      type: Boolean,
      default: false,
    },
    /**
     * SNSに投稿したことがあるかどうか
     */
    postedSns: {
      type: Object as PropType<HighlightPostedSnsType>,
    },
  },
  data(): SnsButtonDataTypes {
    return {
      isActiveXBalloon: false,
      isActiveInstagramBalloon: false,
      timerXId: undefined,
      timerInstagramId: undefined,
      balloonDisplayTime: 3000,
      balloonXStyle: {},
      balloonInstagramStyle: {},
      isXPosted: false,
      isInstagramPosted: false,
    }
  },
  mounted() {
    this.isXPosted = this.postedSns?.x ?? false
    this.isInstagramPosted = this.postedSns?.instagram ?? false
  },
  methods: {
    onChangePostX() {
      this.$emit('onChangePostX', !this.postX)
      if (!this.postX) {
        this.isActiveInstagramBalloon = false
        // バルーンを表示
        this.isActiveXBalloon = true
        if (this.timerXId) {
          window.clearTimeout(this.timerXId)
        }
        this.$nextTick(() => {
          const leftSpace = (this.$refs.balloonX as HTMLElement).getBoundingClientRect().left
          const buttonXSpace = (this.$refs.buttonX as HTMLElement).getBoundingClientRect().left
          if (leftSpace < 20) {
            this.balloonXStyle = { left: `-${buttonXSpace - 20}px`, transform: 'translateX(0)' }
          }
        })
        // 数秒表示後にバルーンを非表示にする
        this.timerXId = window.setTimeout(() => {
          this.isActiveXBalloon = false
        }, this.balloonDisplayTime)
      } else {
        if (this.timerXId) {
          window.clearTimeout(this.timerXId)
        }
        this.isActiveXBalloon = false
      }
    },
    onChangePostInstagram() {
      this.$emit('onChangePostInstagram', !this.postInstagram)
      if (!this.postInstagram) {
        this.isActiveXBalloon = false
        this.isActiveInstagramBalloon = true
        if (this.timerInstagramId) {
          window.clearTimeout(this.timerInstagramId)
        }
        this.$nextTick(() => {
          const leftSpace = (this.$refs.balloonInstagram as HTMLElement).getBoundingClientRect()
            .left
          const buttonInstagramSpace = (
            this.$refs.buttonInstagram as HTMLElement
          ).getBoundingClientRect().left
          if (leftSpace < 20) {
            this.balloonXStyle = {
              left: `-${buttonInstagramSpace - 20}px`,
              transform: 'translateX(0)',
            }
          }
        })
        this.timerInstagramId = window.setTimeout(() => {
          this.isActiveInstagramBalloon = false
        }, this.balloonDisplayTime)
      } else {
        if (this.timerInstagramId) {
          window.clearTimeout(this.timerInstagramId)
        }
        this.isActiveInstagramBalloon = false
      }
    },
  },
  beforeDestroy() {
    if (this.timerXId) {
      window.clearTimeout(this.timerXId)
    }
    if (this.timerInstagramId) {
      window.clearTimeout(this.timerInstagramId)
    }
  },
})
</script>

<style scoped lang="scss">
.highlight-sns-button-parts {
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  padding: 0 8px;

  @media screen and (max-width: $responsiveMinWidth) {
    gap: 12px;
  }

  &__title {
    font-family: $fontSignup;
    font-size: 13px;
    font-weight: 700;
    color: $white;
    letter-spacing: 0.04em;
    white-space: nowrap;

    &-label {
      @media screen and (max-width: $responsiveMinWidth) {
        display: none;
      }
    }

    &-label-short {
      display: none;

      @media screen and (max-width: $responsiveMinWidth) {
        display: block;
      }
    }
  }

  &__buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    &-item {
      position: relative;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    color: $white;
    background-color: rgba(#fff, 0.2);
    border-radius: 6px;

    &-label {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }

    &--active {
      position: relative;
      z-index: 3;
      background-color: transparent;

      .highlight-sns-button-parts__button-label {
        background-color: $black;
      }

      &::after {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 36px;
        height: 36px;
        content: '';
        border: 2px solid $green-light;
        border-radius: 6px;
        transform: translate(-50%, -50%);
      }

      &Balloon {
        &::before {
          position: absolute;
          top: -6px;
          left: 50%;
          width: 7px;
          height: 6px;
          content: '';
          background-color: rgba(#73ffdd, 0.2);
          transform: translateX(-50%);
          clip-path: polygon(0 0, 100% 0, 50% 100%);
        }
      }
    }

    &-check {
      position: absolute;
      top: -10px;
      left: -10px;
      z-index: 1;
      width: 18px;
      height: 18px;
    }
  }

  &__balloon {
    position: absolute;
    bottom: 40px;
    left: 50%;
    z-index: 1;
    transform: translateX(-50%);
  }

  .race-video-highlights-pane--landscape-primary & {
    .highlight-sns-button-parts__title {
      display: none;
    }
  }
}
</style>
